<template>
    <div class="dark-blue hero-img">
    
      <v-container class="px-10 mt-lg-10 mt-xs-6 mt-sm-8 mt-md-8 pt-12 d-flex align-center justify-center fill-height" fluid>
        <v-row cols="12">
            <v-col cols="2"></v-col>
            <v-col cols="12" md="5">
                <h1 class="section__header-title white--text text-h2 font-weight-bold">Collections</h1>
                <h3 class="white--text text-subtitle-1">Automate large-scale decision-making and communication with workflows. Access customers across a variety of mediums. Engage with AI Voice Chats.</h3>
            </v-col>
            
        </v-row>
        
      </v-container>
    </div>
  </template>
  
<script>
    export default {
    name: 'CollectionsHero',
    }
</script>

<style lang="scss" scoped>
.hero-img {
    background: url('../assets/img/call-centre.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 700px;
    position: relative;
    

    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to right, #091531 25%, rgba(0,0,0,0));
        z-index: 1;
    }
    * {
        z-index: 2;
    }

    > * {
        max-width: 2000px;
    }
    
}


.tagline {
    font-size: 1.5em;
}
</style>
  